import React, { useState, useEffect, useRef } from 'react';
import { 
  Container,
  Row,
  Col,
} from 'reactstrap';

import { constants } from '../../types/constants';
import { PRIVILEGE } from '../../types/privileges'
import { connect } from 'react-redux';
import { IVenteInfo, IAuthReduxProps, ITarget } from '../../types/interfaces';
import Select from 'react-select';
import LoadingPage from '../../pages/loading';
import Loading from '../Loading';
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faBuilding, faHashtag, faHouseDamage, faLayerGroup, faMoneyBill, faMoneyBillAlt, faRulerCombined, faThLarge, faCompass, faMap, faQuestionCircle, faSquare, faCheckSquare, faSearch, faBookmark, faMapMarkerAlt, faSignature, faFolder, faFileInvoice, faReceipt, faFileContract, faFilePdf, faSync, faCloudUploadAlt, faHandRock, faTimes, faSpinner, faCheckCircle, faInfoCircle, faPercent, faPen, faCalendarAlt, faFileImage, faBookOpen, faPrint, faFileDownload, faPencilRuler, faCheck, faLockOpen, faDollarSign } from '@fortawesome/free-solid-svg-icons'
import { useHistory, useLocation } from 'react-router-dom';
import { useAlert } from "react-alert";
import ReactTooltip from 'react-tooltip';
import moment from "moment";
import PDFLink, { PreviewBase64, printBase64, downloadBase64, instantUploadToFTP, printBuffer } from '../pdf/PDFLink';

import { getBienStatut } from '../../services/misc';
import VenteNotaireEdit from './VenteNotaireEdit';
import BienPrixModal from '../plan/BienPrixModal';
import AskDoaModal from './AskDoaModal';

const VenteInfoComponent = ({ 
  isBien,
  info,
  bienInfo,
  refreshVente,
  auth
 }: IVenteInfo) => {
  const alert = useAlert();
  const history = useHistory();
  
  const [editVenteModal, setEditVenteModal] = useState(false);
  const [editBienModal, setEditBienModal] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [modalDoa, setModalDoa] = useState(false);
  const [modalDoaBien, setModalDoaBien] = useState<any>(null);

  useEffect(() => {
    const type = (isBien ? bienInfo : info.bien)?.TYPE_2?.toUpperCase()
    switch(type){
      case constants.LOT: setImageUrl("url('/images/soil.png')"); break;
      case constants.VILLA: setImageUrl("url('/images/villa.png')"); break;
      case constants.APPARTEMENT: setImageUrl("url('/images/apartment.png')"); break;
      case constants.MAGASIN: setImageUrl("url('/images/shop.png')"); break;
      case constants.EQUIPEMENT: setImageUrl("url('/images/equipment.png')"); break;
      default: setImageUrl(""); break;
    }
  }, [info.bien?.TYPE_2, bienInfo.TYPE_2])

  return false ? <LoadingPage/> : (
    <>
      {false ? <Loading topSpace /> : (isBien ? bienInfo : info)?.id ? <Container className="CardInfo fadeAnimation">
        <Row className="padding-0">
          <Col xs="12" md="3" className="cardImageContainer">
            <div title={(isBien ? bienInfo : info.bien)?.TYPE_2 || ""} className="cardImage" style={{backgroundImage: imageUrl}}></div>
            <div className="cardImageTitle">{(isBien ? bienInfo : info).TYPE || '-'}</div>
          </Col>
          <Col xs="12" md="9" style={{border: "none"}}>
            <div style={{display: "flex", flexDirection: "row-reverse", justifyContent: "space-between", fontStyle: "italic", fontSize: "x-small"}}>
              <div style={{display: "flex", gap: "5px", flexWrap: "wrap", justifyContent: "center"}}>
                {!!((!isBien && info.bien?.STATUT && ((["DISPONIBLE", "UNIQUE"].includes(info.bien?.STATUT) && info.bien.ASS === "0") && ((!info.bien.demande_ouverture_associations?.length || info.bien.demande_ouverture_associations.filter(e => e.approved !== 0).length === 0))))
                || (isBien && bienInfo.STATUT && ((["DISPONIBLE", "UNIQUE"].includes(bienInfo.STATUT) && bienInfo.ASS === "0") && ((!bienInfo.demande_ouverture_associations?.length || bienInfo.demande_ouverture_associations.filter(e => e.approved !== 0).length === 0))))) && <div className="consultationEditBtn fullFlexCenter" onClick={() => (setModalDoaBien(isBien ? bienInfo : {...(info?.bien || {}), contrat: info}), setModalDoa(true))}>
                  <FontAwesomeIcon icon={faLockOpen} style={{fontSize: "xx-small"}} />&nbsp;<div style={{textDecoration: "underline"}}>Ouvrir en association</div>
                </div>}
                {!!(!isBien && (auth?.user?.privileges?.includes(PRIVILEGE.NOTAIRE_EN_COURS) || auth?.user?.privileges?.includes(PRIVILEGE.SIGNE_NOTAIRE) || (info.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE && (auth?.user?.privileges?.includes(PRIVILEGE.EXPEDITION_MINUTE) || auth?.user?.privileges?.includes(PRIVILEGE.ENREGISTREMENT_MINUTE))))) && <div className="consultationEditBtn fullFlexCenter" onClick={() => {setEditVenteModal(true)}}>
                  <FontAwesomeIcon icon={faSignature} style={{fontSize: "xx-small"}} />&nbsp;<div style={{textDecoration: "underline"}}>Signatures</div>
                </div>}
                {!!auth?.user?.privileges?.includes(PRIVILEGE.CHANGEMENT_PRIX) && <div className="consultationEditBtn fullFlexCenter" onClick={() => {setEditBienModal(true)}}>
                  <FontAwesomeIcon icon={faDollarSign} style={{fontSize: "xx-small"}} />&nbsp;<div style={{textDecoration: "underline"}}>Modifier le prix</div>
                </div>}
                <div className="consultationEditBtn fullFlexCenter" onClick={() => refreshVente()}>
                  <FontAwesomeIcon icon={faSync} style={{fontSize: "xx-small"}} />&nbsp;<div style={{textDecoration: "underline"}}>Actualiser</div>
                </div>
              </div>
              {!!(info.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE || info.en_cours_signature === 1 || info.chez_notaire === 1) && <div className="cardSticker" style={{backgroundColor: info.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE ? "green" : info.en_cours_signature === 1 ? "cadetblue" : info.chez_notaire === 1 ? "brown" : "black", margin: 0, fontSize: "small"}}>{info.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE ? "Signé Notaire" : info.en_cours_signature === 1 ? "Signature En Cours" : info.chez_notaire === 1 ? "Signé Client" : ""}</div>}
            </div>
            {!!isBien && <Row>
              <Col xs="12">
                <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>Statut : </strong>{getBienStatut(bienInfo?.STATUT) || "-"}
              </Col>
            </Row>}
            {(!isBien && !!auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER)) && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faHashtag} />&nbsp;<strong>ID : </strong>{info.id}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faHashtag} />&nbsp;<strong>ID Bien : </strong>{info.ID_BIEN}
              </Col>
            </Row>}
            {!isBien && <Row>
              {/* <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faSignature} />&nbsp;<strong>ID Bien : </strong>{info.ID_BIEN}
              </Col> */}
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faFolder} />&nbsp;<strong>Dossier N° : </strong>{info.NUM_DOSS}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faCalendarAlt} />&nbsp;<strong>Date de vente : </strong>{info.DATE_RESERV ? moment(info.DATE_RESERV).format('DD/MM/YYYY') : "-"}
              </Col>
            </Row>}
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMapMarkerAlt} />&nbsp;<strong>Projet : </strong>{(isBien ? bienInfo : info).PROJET || '-'}
                {/* <FontAwesomeIcon icon={faHouseDamage} />&nbsp;<strong>Type : </strong>{info.TYPE || '-'} */}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faHashtag} />&nbsp;<strong>N° : </strong>{(isBien ? bienInfo : info).N}
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Tranche : </strong>{(isBien ? bienInfo : info).TRANCHE || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faBuilding} />&nbsp;<strong>Immeuble : </strong>{!(isBien ? bienInfo : info).IMMEUBLE && (isBien ? bienInfo : info).IMMEUBLE !== "0" ? "-" : (isBien ? bienInfo : info).IMMEUBLE}
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faLayerGroup} />&nbsp;<strong>Étage N° : </strong>{!(isBien ? bienInfo : info).ETAGE && (isBien ? bienInfo : info).ETAGE !== "0" ? "-" : (isBien ? bienInfo : info).ETAGE}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faRulerCombined} />&nbsp;<strong>Superficie : </strong>{(isBien ? bienInfo : info).TYPE_2?.toUpperCase() === constants.APPARTEMENT ? "-" : ((isBien ? bienInfo : info).SUPERFICIE + "m²")}
              </Col>
            </Row>
            {((isBien ? bienInfo : info).ORIENTATION || (isBien ? bienInfo : info).POSITION) && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faCompass} />&nbsp;<strong>Orientation : </strong>{(isBien ? bienInfo : info).ORIENTATION || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMap} />&nbsp;<strong>Position : </strong>{(isBien ? bienInfo : info).POSITION || "-"}
              </Col>
            </Row>}
            {(!isBien && !!(info.REMISE || info.PRIX_M_CLIENT)) && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faPercent} />&nbsp;<strong>Remise : </strong>{(info.REMISE !== null && info.REMISE !== undefined) ? (<div style={{display: "inline-block", ...(info.REMISE > 0 ? info.REMISE_VALIDEE === -1 ? {color: "orangered"} : info.REMISE_VALIDEE === 0 ? {color: "red"} : {} : {})}}>
                  {info.REMISE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}&nbsp;Dh{info.REMISE > 0 ? " (du total)" : ""}&nbsp;
                  {info.REMISE > 0 && (info.REMISE_VALIDEE === -1 || info.REMISE_VALIDEE === 0) ? <div style={{display: "inline-block"}}>
                    <FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for="remise_tooltip" />
                    <ReactTooltip effect="solid" id="remise_tooltip" type={"dark"}>
                      {info.REMISE_VALIDEE === -1 ? "Demande de remise pas encore validée par l'administration" : info.REMISE_VALIDEE === 0 ? "Demande de remise refusée par l'administration" : ""}
                    </ReactTooltip>
                  </div> : null}
                </div>) : "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix comm. Client : </strong>{(info.PRIX_M_CLIENT !== null && info.PRIX_M_CLIENT !== undefined) ? (info.PRIX_M_CLIENT.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh (du total)") : "-"}
              </Col>
            </Row>}
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBillAlt} />&nbsp;<strong>Prix {isBien ? "Catalogue" : "Net"} M² : </strong>{((isBien ? bienInfo : info).PRIX_M || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix {isBien ? "Catalogue" : "Net"} : </strong>{((isBien ? bienInfo?.PRIX_VENTE : info?.PRIX_NET) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}
              </Col>
            </Row>
            {/* {!!auth?.user?.privileges?.includes(PRIVILEGE.SEE_PRIX_MIN) && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBillAlt} />&nbsp;<strong>Prix (MIN) M² : </strong>{((isBien ? bienInfo : info?.bien)?.PRIX_M_MIN || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix (MIN) : </strong>{((isBien ? bienInfo : info?.bien)?.PRIX_VENTE_MIN || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}
              </Col>
            </Row>} */}
          </Col>
        </Row>
      </Container> : <Container>
        <Row>
          <p className="noTableData">Aucune vente sélectionnée</p>
        </Row>
      </Container>}
      
      <VenteNotaireEdit modal={editVenteModal} setModal={setEditVenteModal} modalData={info} societeId={info?.IDPROJET} />
      <BienPrixModal modal={editBienModal} setModal={setEditBienModal} modalData={isBien ? bienInfo : {...(info?.bien || {}), contrat: info}} />
      <AskDoaModal modal={modalDoa} setModal={setModalDoa} modalData={modalDoaBien} />
    </>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { })(VenteInfoComponent);
